<template lang="pug">
.event-landing-header(
  ref="landingMenu"
  :class=`{
    'fixed': isFixedMenu,
  }`
)
  .event-landing-header__wrapper
    .container
      .event-landing-header__content(
        :class=`[{
          'flex-wrap': $vuetify.breakpoint.smAndDown,
        }, linksContainerClass]`
      )
        template(v-if="isFixedMenu")
          logo-heading(mini)
        template(v-if="!$vuetify.breakpoint.smAndDown")
          template(v-for="link in links")
            .event-landing-header__link.text-nowrap(
              :key="link.id"
              :class=`{
                'redesignPrimaryDarken--text weight-600': isActiveLink(link.id),
              }`
              @click="scrollToSection(link.id)"
            ) {{ link.name }}
        template(v-else)
          expand-menu(
            :type="constants.MENU_TYPES.INDEPEND"
            additional-menu-classes="redesign rounded-12 redesign-box-shadow"
            bottom
            left
          )
            template(#activator="{ on, attrs }")
              app-button(
                icon
                v-bind="attrs"
                v-on="on"
              )
                v-icon(
                  color="redesignBlack"
                ) mdi-menu
            v-list.redesignBlack--text
              template(v-for="link in links")
                v-list-item(
                  :key="link.id"
                  @click="scrollToSection(link.id)"
                ) {{ link.name }}
        slot(name="inner-append")

</template>

<script>
import LogoHeading from '@/components/user-redesign/layout/TheHeader/LogoHeading.vue';
import ExpandMenu, { MENU_TYPES } from '@/components/user-redesign/ExpandMenu.vue';
import { scrollTo } from '@/modules/UserEventLanding/functions';

export default {
  name: 'HeaderScrollLinks',
  components: {
    ExpandMenu,
    LogoHeading,
  },
  props: {
    /**
     * @links - Array [{ name, id }]
     */
    links: {
      type: Array,
      default: () => [],
    },
    /**
     * @observerIds is ids of @links
     */
    observerIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFixedMenu: false,
    };
  },
  computed: {
    constants() {
      return {
        MENU_TYPES,
      };
    },
    lastObserverId() {
      return [...this.observerIds].pop();
    },
    linksContainerClass() {
      switch (this.links.length || []) {
        case 1: return 'justify-center';
        case 2: return 'justify-space-around';
        default: return 'justify-space-between';
      }
    },
  },
  watch: {},
  mounted() {
    this.$vuetify.goTo(0, { duration: 0 });
    document.addEventListener('scroll', this.toggleFixedPosToMenu);
    // document.addEventListener('scroll', this.makeActiveLink);
    this.toggleFixedPosToMenu();
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.toggleFixedPosToMenu);
    // document.removeEventListener('scroll', this.makeActiveLink);
  },
  methods: {
    scrollToSection(id) {
      const anchor = `#${id}`;
      scrollTo(anchor);
    },
    toggleFixedPosToMenu() {
      const { landingMenu } = this.$refs;

      if (!landingMenu) {
        return;
      }

      // const posTop = landingMenu.getBoundingClientRect().top;

      // if (posTop <= -80 && !this.isFixedMenu) {
      //   this.isFixedMenu = true;
      // }

      // if (posTop + landingMenu.clientHeight <= window.innerHeight && posTop >= 0 && posTop >= 0 && this.isFixedMenu) {
      //   this.isFixedMenu = false;
      // }
      const containerHeight = landingMenu.getBoundingClientRect().height;
      const { scrollTop } = document.documentElement;
      if (scrollTop >= containerHeight && !this.isFixedMenu) {
        this.isFixedMenu = true;
      }
      if (scrollTop <= containerHeight && this.isFixedMenu) {
        this.isFixedMenu = false;
      }
    },
    isActiveLink(id) {
      return this.lastObserverId === id;
    },
  },
};
</script>

<style scoped lang="scss">
.event-landing-header {
  width: 100%;
  height: $landing-menu-height;
  z-index: 3;

  &.fixed .event-landing-header__wrapper {
    position: fixed;
    background-color: #fff;
    top: 0;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #{$primary};
    transition: 0.3s;
    animation-name: fixedMenu;
    animation-duration: 0.3s;
  }

  &.fixed .container {
    padding: 0 20px !important;
  }

  &__wrapper {
    height: $landing-menu-height;
    width: 100%;
    padding: 16px 0;
    box-sizing: border-box;
  }

  .container {
    padding: 0 !important;
  }

  &__content {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 24px;
  }

  &__link {
    color: #{$redesignBlack};
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      color: #{$redesignPrimaryDarken};
    }
    &.active {
      color: #{$redesignPrimaryDarken};
    }
  }
}

@keyframes fixedMenu {
  from {
    // height: 0;
    transform: translateY(-80px);
  }

  to {
    // height: 80px;
    transform: translateY(0px);
  }
}
</style>
